import {connect} from "react-redux";
import React from "react";

const Nav_Links_Item = (props) => {
    const { classTitle,text } = props;

    return(
        <div className={`nav_links_item_div background_change_hover background_change_hover_${props.color_background}`}>
            <div className="nav_links_item_icon_div">
                <i className={`background_color_text_${props.color_background} fa-solid ${classTitle}`}></i>
            </div>
            <span className={`nav_links_item_text background_color_text_${props.color_background}`} id={`nav_links_item_${text}`}>{text}</span>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        color_background: state.getColorBackground.color_background
    }
}
export default connect(mapStateToProps)(Nav_Links_Item);